import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";
import { SrFaxManagementApi } from "../../../services";

interface UseGetFaxOutgoingByUuidProps {
  faxOutgoingUuid?: string;
  enabled?: boolean;
}

/**
 *
 * @author Atish Bagate
 */
export function useGetFaxOutgoingByUuid({
  faxOutgoingUuid,
  enabled,
}: UseGetFaxOutgoingByUuidProps): useBaseContent<any> {
  return useQuery({
    queryKey: ["get-fax-outgoing-by-id", faxOutgoingUuid],
    enabled: enabled ?? !!faxOutgoingUuid,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new SrFaxManagementApi(getConfigObject())
        .getFaxDocumentById(faxOutgoingUuid!, getXtenantId())
        .then((res) => res?.data),
  });
}
